<template>
    <vs-list>
        <vs-list-item v-for="(file, index) in data" :key="index" :title="file.name"> 
           <action-icon icon="DownloadIcon" :tooltip="$t('download')" @click="download(file)" class="text-danger"></action-icon>
        </vs-list-item>
    </vs-list>
</template>

<script>
import request from './request.js'
import ActionIcon from '@/views/qb-components/actions/ActionIcon.vue'
export default {
    components:{
        ActionIcon
    },
    props: {
        data: {
            type: Array,
            default: () => []
        },
    },
    methods:{
          download(file) { 

            let new_url = file.url
            window.open(new_url)
            //delete link;

            // const payload = {
            //     id: file.id
            // }
            // request
            //     .downloadAttachment(payload)
            //     .then((response) => {
            //         let fileURL = window.URL.createObjectURL(new Blob([response.data],{type: "application/vnd.ms-excel"}));
            //         let fileLink = document.createElement('a');

            //         fileLink.href = fileURL;
            //         fileLink.setAttribute('download', file.name);
            //         document.body.appendChild(fileLink);

            //         fileLink.click();
            //     })
            //     .catch((response) => {
            //         console.log(response)
            //         //this.showValidationErrors(response)
            //     })
        }
    }

 
}
</script>

<style></style>